import React, {FC} from "react";

type Props = {
    image: string;
    description: string;
};
const Details: FC<Props> = ({image, description}) => {
    return (
        <div className="mt-4 flex flex-col gap-x-2 px-[10%] md:mt-10 lg:px-[13%] xl:mt-16 xl:flex-row">
            {/* <img
                alt="انجمن"
                src={image}
                className="mb-4 w-full rounded md:mb-10 lg:mb-0 xl:w-[34%]"
            ></img> */}
            <div className="w-full rounded bg-white px-[30px] py-[34px] shadow lg:shadow-md xl:w-[66%]">

                <div dangerouslySetInnerHTML={{__html: description}}></div>
                {/* <div className="my-5 h-px w-full bg-[#4F9B0B]/20 3xl:my-12"></div> */}
                {/* <div className="flex w-full justify-between">
                    <div className="flex items-center">
                        <Conversation className="ml-5" />
                        <div>
                            <span className="text-sm md:text-base">
                                گفتگو با دوستان در دادبانان
                            </span>
                            <span className="flex items-center text-xs text-blue-550 md:text-sm lg:hidden">
                                کلیک کن و وارد شو
                                <FillArrow className="mr-2" />
                            </span>
                        </div>
                    </div>
                    <div className="hidden flex-col justify-around lg:flex">
                        <span className="flex items-center gap-x-[20px] text-xs text-blue-550 md:text-sm">
                            کلیک کن و وارد شو
                            <FillArrow />
                        </span>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Details;
